import React from "react";
import { AlertTriangle } from "lucide-react";

// ------------------------------------------------------------
// Payment Failed Card
// ------------------------------------------------------------

interface Props {
  message: string;
  failureReason?: string | null;
}

const PaymentFailedCard: React.FC<Props> = ({
  message,
  failureReason,
}) => {
  return (
    <div className="bg-white rounded-2xl border border-red-200 shadow-3xs p-8 text-center">

      {/* Failure Icon */}
      <div className="flex justify-center mb-4">
        <AlertTriangle
          className="w-10 h-10 text-red-500"
          strokeWidth={2.2}
        />
      </div>

      {/* Title */}
      <h2 className="text-lg font-black text-red-600 text-center">
        Payment Failed
      </h2>

      {/* Main Message */}
      <p className="text-sm text-slate-500 mt-2 text-center">
        {message}
      </p>

      {/* Failure Reason */}
      {failureReason && (
        <div className="mt-5 bg-red-50 border border-red-100 rounded-xl p-4 text-center">

          <p className="text-[10px] font-black uppercase tracking-wider text-red-600">
            Failure Reason
          </p>

          <p className="text-sm font-semibold text-slate-700 mt-1">
            {failureReason}
          </p>

        </div>
      )}

    </div>
  );
};

export default PaymentFailedCard;